import { render, staticRenderFns } from "./RequestUserAgent.vue?vue&type=template&id=bd5cb750&scoped=true&"
import script from "./RequestUserAgent.vue?vue&type=script&lang=js&"
export * from "./RequestUserAgent.vue?vue&type=script&lang=js&"
import style0 from "./RequestUserAgent.vue?vue&type=style&index=0&id=bd5cb750&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd5cb750",
  null
  
)

export default component.exports